import wallets from './wallets';
import addresses from './addresses';

let config = {
    'wallets': wallets,
    'addresses': addresses
};

export default config;